var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSearchOff = function SvgSearchOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "search_off_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#search_off_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.667 14.2a2.895 2.895 0 0 1-2.125-.875 2.895 2.895 0 0 1-.875-2.125c0-.833.292-1.542.875-2.125A2.895 2.895 0 0 1 4.667 8.2c.833 0 1.542.292 2.125.875s.875 1.292.875 2.125-.292 1.542-.875 2.125a2.895 2.895 0 0 1-2.125.875Zm-1.383-1.617c.066.067.136.1.208.1.072 0 .142-.033.208-.1l.967-.966.967.966c.055.067.122.1.2.1a.252.252 0 0 0 .2-.1.26.26 0 0 0 .1-.208.26.26 0 0 0-.1-.208l-.95-.967.966-.967a.306.306 0 0 0 .092-.2.274.274 0 0 0-.092-.216.322.322 0 0 0-.208-.084.322.322 0 0 0-.208.084l-.967.966-.967-.966a.273.273 0 0 0-.2-.084.332.332 0 0 0-.216.084.303.303 0 0 0-.1.216c0 .078.033.145.1.2l.966.967-.966.967a.373.373 0 0 0-.092.216.228.228 0 0 0 .092.2Zm10.05.784L9.45 9.483a.875.875 0 0 1-.208.15A3.206 3.206 0 0 1 9 9.75a8.148 8.148 0 0 0-.283-.367A3.02 3.02 0 0 0 8.4 9.05c.5-.244.906-.606 1.217-1.083a2.927 2.927 0 0 0 .467-1.634c0-.855-.3-1.583-.9-2.183-.6-.6-1.328-.9-2.184-.9-.855 0-1.583.3-2.183.9-.6.6-.9 1.328-.9 2.183 0 .1.008.2.025.3.017.1.036.2.058.3a2.531 2.531 0 0 0-.5.092c-.177.05-.339.108-.483.175a33.774 33.774 0 0 1-.067-.417 2.956 2.956 0 0 1-.033-.45c0-1.133.397-2.097 1.191-2.892C4.903 2.647 5.867 2.25 7 2.25c1.134 0 2.098.397 2.892 1.191.795.795 1.192 1.759 1.192 2.892 0 .478-.081.93-.242 1.358a4.15 4.15 0 0 1-.642 1.142l3.834 3.834a.48.48 0 0 1 0 .7.48.48 0 0 1-.7 0Z",
    fill: "#fff"
  }))));
};

export default SvgSearchOff;